
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/(ocelot)/video",
      function () {
        return require("private-next-pages/(ocelot)/video/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/(ocelot)/video"])
      });
    }
  